import * as React from 'react';

export const AppVisualStateContext = React.createContext<string[]>(null);